











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.User.GrantUserDashboardsCommand')
    
    export class GrantUserDashboardsCommand {
        constructor( userId: number, dashboardId: number, grantLevel: number ) {
            
                this.userId = userId;
            
                this.dashboardId = dashboardId;
            
                this.grantLevel = grantLevel;
            
        }

        
            public userId: number;
        
            public dashboardId: number;
        
            public grantLevel: number;
        
    }

    export interface IGrantUserDashboardsCommand {
        
            userId: number;
        
            dashboardId: number;
        
            grantLevel: number;
        
    }

    export async function grantUserDashboards( command: GrantUserDashboardsCommand ): Promise<CommandResult<void>>
    export async function grantUserDashboards( { userId, dashboardId, grantLevel }: IGrantUserDashboardsCommand ): Promise<CommandResult<void>>
    export async function grantUserDashboards( model: any ): Promise<CommandResult<void>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<void>;

        if(model instanceof GrantUserDashboardsCommand) {
            result = await endpoint.send<CommandResult<void>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<void>>( new GrantUserDashboardsCommand( model['userId'], model['dashboardId'], model['grantLevel'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace GrantUserDashboardsCommand.ExtraneousTypes {
        

        
    }

